var path = 'src/app/forms/group-inline.html';
var html = "<div ng-class=\"{'required': isRequired()}\" frm-status ng-transclude></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/group-inline.html
 ** module id = 326
 ** module chunks = 0
 **/